<div class="tw-flex tw-items-center tw-h-full">
  <svg class="tw-text-dt-text-headings tw-h-5 tw-w-5">
    <use xlink:href="images/sprite.svg#right-arrow"></use>
  </svg>
</div>
